<ng-container *ngIf="post$ | async; let post; else: loading">
    <div class="post-wrapper">
        <ng-container *ngIf="user$ | async; let user">
            <app-post-item [user]="user" [fullPostBody]="true" [expandAll]="true" [post]="post"></app-post-item>
        </ng-container>
    </div> </ng-container
><ng-template #loading>
    <app-kd-logo-loading></app-kd-logo-loading>
</ng-template>
